<template>
  <div>
    <v-dialog
      v-model="internalShow"
      :width="dialogWidth"
      max-width="1500px"
      min-width="350px"
      persistent
    >
      <v-card v-if="!isSaving">
        <v-card-title class="text-h4 ml-3">
          Edit Step - {{ value.key }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="close" v-bind="attrs" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <h3>Details</h3>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="internalValue.title"
                    label="Title"
                    placeholder="Please enter title"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="internalValue.order"
                    label="Order"
                    placeholder="Order"
                    type="number"
                  />
                </v-col>
                <v-col cols="2">
                  <v-switch
                    v-model="internalValue.display"

                    :label="`Display: ${internalValue.display? 'Yes':'No'}`"
                  ></v-switch>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="internalValue.description"
                    label="Description"
                    placeholder="Please enter description"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="internalValue.help"
                    label="Help"
                    placeholder="Please enter help text"
                  />
                </v-col>
                
                <v-col cols=12>
                  <step-images-editor v-model="internalValue.images" />
                </v-col>

                <!-- Condition -->
                <v-col cols="12">
                  <conditions-editor v-model="internalValue.conditions" />
                </v-col>

                <!-- Validation -->
                <v-col cols="12">
                  <validations-editor v-model="internalValue.validation" />
                </v-col>

                <!-- Answer -->
                <v-col cols="12">
                  <answers-editor v-model="internalValue.answers" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large class="primary-btn" @click="save">Save</v-btn>
          <v-btn large class="danger-btn" @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <div class="waiting-assessment-card">
          <v-card-title>
            <div class="waiting-assessment-title">Saving...</div>
          </v-card-title>
          <v-card-text class="waiting-assessment-content">
            <img :src="img_src" />
            <p>Please wait whilst we are saving.</p>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="savedDialog.show"
      width="50%"
      max-width="1500px"
      min-width="350px"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ savedDialog.title }}
        </v-card-title>
        <v-card-text>
          {{ savedDialog.message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large class="primary-btn" @click="savedDialog.show = false">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Conditions from './node/Conditions.vue';
import Validations from './node/Validations.vue';
import Answers from './node/Answers.vue';
import Images from './node/Images.vue';

let img_src = require("@/assets/img/zink-logo-loading-animation-color.gif");

export default {
  components: {
    'conditions-editor': Conditions,
    'validations-editor': Validations,
    'answers-editor': Answers,
    'step-images-editor': Images,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      img_src,
      internalValue: this.value,
      originalValue: JSON.stringify(this.value),
      internalShow: this.show,
      isSaving: false,
      newCondition: {
        path: '',
        comparison: '==',
        value: '',
        step: '',
        editing: false,
      },
      newValidation: {
        field: '',
        required: true,
        label: '',
        editing: false,
      },
      savedDialog: {
        show: false,
        title: "",
        message: "",
      }
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.internalValue = newValue;
      },
      deep: true,
    },
    show(newShow) {
      this.internalShow = newShow;
      if (newShow) {
        this.originalValue = JSON.stringify(this.value);
      }
    },
    internalValue: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true,
    },
    internalShow(newShow) {
      this.$emit('update:show', newShow);
    },
    // Specifically watch for changes to internalValue.order
    'internalValue.order': {
      handler(newValue) {
        // Convert the order to a number if it's not already
        if (newValue !== null && newValue !== undefined) {
          const numericValue = Number(newValue);
          if (!isNaN(numericValue)) {
            this.internalValue.order = numericValue;
          } else {
            console.warn('Invalid order value:', newValue);
          }
        }
      },
      immediate: true, // Run this handler immediately upon initialization
    },
  },
  computed: {
    dialogWidth() {
      return this.isSaving ? '15%' : '85%';
    },
  },
  methods: {
    ...mapActions('journey', ['saveJourneyStep']),
    async save () {
      this.isSaving = true;
      try {
        await this.saveJourneyStep(this.internalValue);
        this.savedDialog.show = true;
        this.savedDialog.title = "Journey Step Saved Successfully";
        this.savedDialog.message = "Your changes has been saved successfully!";
      } catch (error) {
        this.savedDialog.show = true;
        this.savedDialog.title = "Failed";
        this.savedDialog.message = error;
      } finally {
        this.originalValue = JSON.stringify(this.internalValue);
        this.isSaving = false;
      }
    },
    close () {
      this.internalValue = JSON.parse(this.originalValue);
      this.$emit('input', this.internalValue);
      this.internalShow = false;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/theme.scss";

.waiting-assessment-card {
  background: $ausloans-blue-hover !important;
  color: $color-text-on-dark !important;
  width: auto;

  .waiting-assessment-title {
    padding-top: 20px;
  }

  .waiting-assessment-content {
    display: flex;
    flex-direction: column;

    & img {
      width: 100px;
      align-self: center;
    }

    & p {
      margin-top: 16px;
    }
  }
}

.primary-btn {
  color: white;
  background-color: $ausloans-blue !important;
}

.danger-btn {
  color: white;
  background-color: $ausloans-red !important;
}
</style>